import { Component, Input } from '@angular/core';
import { CellDataType } from '../../interfaces/data-import/cell-data-type';
import { IImportEntry } from '../../interfaces/data-import/import-entry';
import { IImportEntryCell } from '../../interfaces/data-import/import-entry-cell';

//import moment from 'moment';

@Component({
  selector: 'import-errors',
  templateUrl: './import-errors.component.html',
  styleUrls: ['./import-errors.component.css'],
})
export class ImportErrorsComponent {
  columns: { header: string; field: string }[] = [];
  invalidEntriesWrappers: any[] = [];
  dialogIsVisible = false;
  cellsForDetails: IImportEntryCell[] = [];
  entry: IImportEntry;

  private _invalidEntries: IImportEntry[];

  @Input()
  set invalidEntries(value: IImportEntry[]) {
    this._invalidEntries = value || [];
    this.refreshColumns(value);
    this.invalidEntriesWrappers = value ? value.map(this.createWrapper) : [];
  }

  get invalidEntries() {
    return this._invalidEntries;
  }

  showDetails(entry: IImportEntry): void {
    this.entry = entry;
    this.cellsForDetails = entry.cells.filter((c) => c.errorMessage);
    this.dialogIsVisible = true;
  }

  onDetailsHide() {
    this.cellsForDetails = [];
  }

  private createWrapper(entry: IImportEntry): any {
    let wrapper = { entry: entry, lineNumber: entry.lineNumber, error: entry.errorMessage };
    for (let i = 0; i < entry.cells.length; i++) {
      let cell = entry.cells[i];

      if (cell.errorMessage) {
        wrapper[cell.targetFieldName] = cell.value;
      } else {
        switch (cell.type) {
          case CellDataType.Date:
            //wrapper[cell.targetFieldName] = moment(cell.value).format('DD/MM/YYYY');
            break;
          default:
            wrapper[cell.targetFieldName] = cell.value;
        }
      }
    }
    return wrapper;
  }

  private refreshColumns(entries: IImportEntry[]): void {
    let cols = [];

    if (entries && entries.length) {
      let entry: IImportEntry = entries[0];

      for (let i = 0; i < entry.cells.length; i++) {
        let cell = entry.cells[i];

        let col = { header: cell.targetFieldName, field: cell.targetFieldName };
        cols[cell.orderNumber - 1] = col;
      }
    }

    this.columns = cols;
  }
}
